"use strict";

var _objectSpread = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapNodeList = mapNodeList;
exports.bindChildren = bindChildren;
exports.translateNode = translateNode;
exports.translateDocument = translateDocument;
var _TTextCtor = require("../tree/TTextCtor");
var _TPhrasingCtor = require("../tree/TPhrasingCtor");
var _TBlockCtor = require("../tree/TBlockCtor");
var _TDocumentImpl = require("../tree/TDocumentImpl");
var _domUtils = require("../dom/dom-utils");
var _TEmptyCtor = require("../tree/TEmptyCtor");
function mapNodeList(_ref) {
  var nodeList = _ref.nodeList,
    parent = _ref.parent,
    parentStyles = _ref.parentStyles,
    params = _ref.params;
  var nextMap = [];
  for (var i in nodeList) {
    var child = nodeList[i];
    var translated = translateNode({
      node: child,
      parentStyles: parentStyles,
      params: params,
      nodeIndex: Number(i),
      parent: parent
    });
    if (translated) {
      nextMap.push(translated);
    }
  }
  return nextMap;
}
function bindChildren(node, children, params) {
  if (!node.elementModel || !node.elementModel.isOpaque) {
    node.bindChildren(mapNodeList({
      nodeList: children,
      parent: node,
      params: params
    }));
  }
}
function translateElement(_ref2) {
  var node = _ref2.node,
    nodeIndex = _ref2.nodeIndex,
    params = _ref2.params,
    parent = _ref2.parent,
    parentStyles = _ref2.parentStyles;
  var tagName = node.tagName;
  var sharedProps = {
    nodeIndex: nodeIndex,
    parentStyles: parentStyles,
    context: params,
    domNode: node,
    parent: parent
  };
  var elementModel = params.modelRegistry.getElementModelFromTagName(tagName);
  if (!elementModel) {
    return new _TEmptyCtor.TEmptyCtor(_objectSpread(_objectSpread({}, sharedProps), {}, {
      isUnregistered: true,
      elementModel: elementModel,
      domNode: node
    }));
  }
  if (elementModel.isTranslatableTextual()) {
    if (node.children.length === 1) {
      var child = node.children[0];
      if ((0, _domUtils.isDomText)(child)) {
        return new _TTextCtor.TTextCtor(_objectSpread(_objectSpread({}, sharedProps), {}, {
          elementModel: elementModel,
          textNode: child,
          domNode: node
        }));
      }
    } else if (node.children.length === 0) {
      return new _TTextCtor.TTextCtor(_objectSpread(_objectSpread({}, sharedProps), {}, {
        elementModel: elementModel,
        domNode: node,
        textNode: new _domUtils.Text('')
      }));
    }
    var phrasing = new _TPhrasingCtor.TPhrasingCtor(_objectSpread(_objectSpread({}, sharedProps), {}, {
      domNode: node,
      elementModel: elementModel
    }));
    bindChildren(phrasing, node.children, params);
    return phrasing;
  }
  if (elementModel.isTranslatableBlock()) {
    var block = new _TBlockCtor.TBlockCtor(_objectSpread(_objectSpread({}, sharedProps), {}, {
      elementModel: elementModel,
      parentStyles: parentStyles,
      domNode: node
    }));
    bindChildren(block, node.children, params);
    return block;
  }
  return new _TEmptyCtor.TEmptyCtor(_objectSpread(_objectSpread({}, sharedProps), {}, {
    isUnregistered: false,
    elementModel: elementModel,
    domNode: node
  }));
}
function translateNode(_ref3) {
  var node = _ref3.node,
    parentStyles = _ref3.parentStyles,
    params = _ref3.params,
    nodeIndex = _ref3.nodeIndex,
    parent = _ref3.parent;
  if ((0, _domUtils.isDomText)(node)) {
    return new _TTextCtor.TTextCtor({
      textNode: node,
      context: params,
      parentStyles: parentStyles,
      domNode: null,
      elementModel: null,
      nodeIndex: nodeIndex,
      parent: parent
    });
  }
  if ((0, _domUtils.isDomElement)(node)) {
    return translateElement({
      node: node,
      parentStyles: parentStyles,
      params: params,
      nodeIndex: nodeIndex,
      parent: parent
    });
  }
  return null;
}
function translateDocument(document, params) {
  var tdoc = new _TDocumentImpl.TDocumentCtor({
    context: params,
    styles: params.baseStyles,
    domNode: document
  });
  bindChildren(tdoc, document.children, params);
  tdoc.parseChildren();
  return tdoc;
}